<div class="commom_textarea_Container">
    <label *ngIf="textArealabel" for="exampleFormControlTextarea1" class="form-label">Example textarea</label>
    <textarea autocomplete="disabled" class="form-control" id="exampleFormControlTextarea1" rows="3"></textarea>
</div>